import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5ff06a36")
const _hoisted_1 = { class: "card-icons" }
const _hoisted_2 = ["title"]
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dig-ui-icon", {
  type: "upload",
  class: "icon-button"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "points" }
const _hoisted_11 = { class: "date" }
const _hoisted_12 = {
  key: 0,
  class: "report"
}
const _hoisted_13 = { class: "center title-3 small-margin" }
const _hoisted_14 = { key: 1 }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_control_grid = _resolveComponent("base-control-grid")!
  const _component_story_form_card = _resolveComponent("story-form-card")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, {
    class: _normalizeClass(["card-story", { editing: _ctx.editing }])
  }, {
    default: _withCtx(() => [
      (!_ctx.editing)
        ? (_openBlock(), _createBlock(_component_base_control_grid, {
            key: 0,
            sideWidth: 140
          }, {
            right: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (_ctx.canEdit && !_ctx.editing)
                  ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                      key: 0,
                      type: "edit",
                      class: "icon-button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editing = true)),
                      title: _ctx.$t('edit')
                    }, null, 8, _hoisted_2))
                  : _createCommentVNode("", true),
                (!_ctx.editing)
                  ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                      key: 1,
                      type: "show",
                      class: "icon-button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToStory())),
                      title: _ctx.$t('show')
                    }, null, 8, _hoisted_3))
                  : _createCommentVNode("", true),
                (_ctx.canEdit)
                  ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                      key: 2,
                      type: "add",
                      class: "icon-button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.duplicateStory())),
                      title: _ctx.$t('duplicate')
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true),
                (_ctx.story.hasReport)
                  ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                      key: 3,
                      type: "download",
                      class: "icon-button",
                      title: _ctx.$t('downloadReport'),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadReport()))
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true),
                (_ctx.canEdit)
                  ? (_openBlock(), _createElementBlock("dig-input-file", {
                      key: 4,
                      onLoaded: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addReport($event))),
                      accept: ".pdf",
                      title: _ctx.$t('addReport')
                    }, _hoisted_8, 40, _hoisted_6))
                  : _createCommentVNode("", true),
                (_ctx.canEdit)
                  ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                      key: 5,
                      type: "delete",
                      class: "icon-button",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteStory())),
                      title: _ctx.$t('delete')
                    }, null, 8, _hoisted_9))
                  : _createCommentVNode("", true)
              ])
            ]),
            left: _withCtx(() => [
              _createElementVNode("dig-ui-badge", _hoisted_10, _toDisplayString(_ctx.story.points) + " pts", 1),
              _createElementVNode("dig-ui-badge", _hoisted_11, _toDisplayString(_ctx.date), 1),
              (_ctx.story.hasReport)
                ? (_openBlock(), _createElementBlock("dig-ui-badge", _hoisted_12, _toDisplayString(_ctx.$t('report')), 1))
                : _createCommentVNode("", true)
            ]),
            middle: _withCtx(() => [
              _createElementVNode("dig-ui-title", _hoisted_13, _toDisplayString(_ctx.story.name), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.editing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_story_form_card, {
              class: "form",
              title: _ctx.$t('editStory'),
              onValidate: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateStory($event))),
              onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editing = false)),
              disabled: _ctx.disabledFormButton,
              story: _ctx.story
            }, null, 8, ["title", "disabled", "story"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}